











import {Component, Vue, Watch} from 'vue-property-decorator';
import PageHeader from '@/shared/components/pageHeader/PageHeader.vue';
import {TabItem} from '@/shared/components/pageHeader/tabItem';
import {Action, Getter} from 'vuex-class';
import {ON_REPORT_VIEW_EXIT} from '@/store/reports/actionTypes';
import {Route} from 'vue-router';
import {NLP_ENABLED} from '@/store/app/featureTypes';
import ReportFilters from '@/features/reports/components/ReportFilters.vue';

@Component({
	components: {
		PageHeader,
		ReportFilters
	}
})
export default class Reports extends Vue {
	@Action(ON_REPORT_VIEW_EXIT) public onReportExit: any;
	@Getter public isWorkspaceFeatureEnabled!: (key: string) => boolean;

	public activeRoute: Route;

	public beforeRouteLeave(to: Route, from: Route, next: any) {
		this.handleOnTabExit(to, from);
		next();
	}

	@Watch('$route', {immediate: true})
	public onRoute(to: Route, from: Route) {
		this.activeRoute = to;
		if (from && from.path.includes('/reports/')) {
			this.handleOnTabExit(to, from);
		}
	}

	public get tabs(): TabItem[] {
		const tabs = [
			{ name: 'Overview', route: 'reports-overview'},
			{ name: 'Usage', route: 'reports-usage'},
			{ name: 'Flows', route: 'reports-flows'},
		];

		if (this.isWorkspaceFeatureEnabled(NLP_ENABLED)) {
			tabs.push({ name: 'Intents', route: 'reports-intents'});
		}

		return tabs;
	}

	private handleOnTabExit(to: Route, from: Route) {
		const fromName = from ? from.name : '';
		const toName = to ? to.name : '';
		this.onReportExit({from: fromName, to: toName});
	}
}
